import { AlertProps } from "@amzn/awsui-components-react-v3";
import React from "react";

/* key/value instead of array in order to help prevent duplicate alerts */
export interface Alerts {
  [key: string]: {
    message: React.ReactNode;
    ariaLabel: string;
    type: AlertProps.Type;
    autoDismiss?: boolean;
    autoDismissSeconds?: number;
  };
}

export enum EndSessionAction {
  ActionEndSession = "log_out",
  ActionCancelEndSession = "stay_logged_in",
}
